import { z } from 'zod';
export var AgentPrincipalStatus;
(function (AgentPrincipalStatus) {
    AgentPrincipalStatus["Active"] = "active";
    AgentPrincipalStatus["Suspended"] = "suspended";
    AgentPrincipalStatus["Unverified"] = "unverified";
})(AgentPrincipalStatus || (AgentPrincipalStatus = {}));
export const agentPrincipalStatusGuard = z.nativeEnum(AgentPrincipalStatus);
export var AgentTrustLevel;
(function (AgentTrustLevel) {
    AgentTrustLevel["ControllerVerified"] = "controller_verified";
    AgentTrustLevel["Unverified"] = "unverified";
})(AgentTrustLevel || (AgentTrustLevel = {}));
export const agentTrustLevelGuard = z.nativeEnum(AgentTrustLevel);
export var AgentRuntimeKind;
(function (AgentRuntimeKind) {
    AgentRuntimeKind["ClaudeCode"] = "claude_code";
    AgentRuntimeKind["Codex"] = "codex";
    AgentRuntimeKind["Other"] = "other";
    AgentRuntimeKind["Workers"] = "workers";
})(AgentRuntimeKind || (AgentRuntimeKind = {}));
export const agentRuntimeKindGuard = z.nativeEnum(AgentRuntimeKind);
export var AgentRuntimeInstanceStatus;
(function (AgentRuntimeInstanceStatus) {
    AgentRuntimeInstanceStatus["Active"] = "active";
    AgentRuntimeInstanceStatus["Pending"] = "pending";
    AgentRuntimeInstanceStatus["Revoked"] = "revoked";
    AgentRuntimeInstanceStatus["Suspended"] = "suspended";
})(AgentRuntimeInstanceStatus || (AgentRuntimeInstanceStatus = {}));
export const agentRuntimeInstanceStatusGuard = z.nativeEnum(AgentRuntimeInstanceStatus);
